<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-tasks mr-1"></i> Atividades
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <!-- Create -->
                        <a href="/teacher/tasks/create" class="btn btn-primary ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0">
                            Criar Atividade
                        </a>

                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container">

            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Nome da Atividade">
                        <b-form-input
                            v-model="filter.name"
                            @change="load"
                            placeholder="Buscar por nome da atividade ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Turma">
                        <multiselect
                            v-model="filter.group_id"
                            :options="groups"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Buscar por Turma ..."
                            tag-placeholder="Filtrar por Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">
                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>
                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Modo de Correção">
                        <multiselect
                            v-model="filter.mode_id"
                            :options="modes"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Filtrar por Modo de Correção ..."
                            tag-placeholder="Filtrar Modo de Correção"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há modos de correção disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Corretor">
                        <!-- Input -->
                        <multiselect
                            v-model="filter.teacher_id"
                            :options="teachers"
                            track-by="id"
                            label="name"
                            placeholder="Filtrar por Corretor"
                            tag-placeholder="Filtrar por Corretor"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há corretores disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <b-card class="mb-4">
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                <!-- Loading -->
                <template #loading>
                    <b-skeleton-table
                        :rows="lastResultsCount"
                        :columns="6"
                        :table-props="{ bordered: true, striped: true }"
                    >
                    </b-skeleton-table>
                </template>

                <!-- Table -->
                <b-table
                    id="tasksTable"
                    :items="table"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="changeSortable"
                    empty-text="Não encontramos nenhum resultado na busca :("
                    class="bg-white mb-0"
                    stacked="md"
                    :sticky-header="true"
                    show-empty
                    no-local-sorting
                    bordered
                    hover>

                    <template v-slot:cell(group.name)="row">
                        <span v-if="row.item.group">
                            <span v-if="row.item.group.name" v-b-tooltip.hover :title="row.item.group.name">
                                {{ row.item.group.name | truncate(25) }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(theme.title)="row">
                        <span v-if="row.item.theme">
                            <span v-if="row.item.theme.title" v-b-tooltip.hover :title="row.item.theme.title">
                                <a :href="'/teacher/themes/' + row.item.theme.id" target="_blank">
                                    {{ row.item.theme.title | truncate(20) }}
                                </a>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                        <span v-else>

                            <span v-if="row.item.mode">
                                <span v-if="row.item.mode.name" v-b-tooltip.hover :title="row.item.mode.name">
                                    {{ row.item.mode.name | truncate(20) }}
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </span>

                        </span>
                    </template>

                    <template v-slot:cell(teacher.name)="row">
                        <span v-if="row.item.teacher">
                            <span v-if="row.item.teacher.name" v-b-tooltip.hover :title="row.item.teacher.name">
                                {{ row.item.teacher.name | truncate(20) }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(from)="row">
                        <span>
                            {{ row.item.from | moment('DD/MM/YYYY HH:mm') }}
                        </span>
                    </template>

                    <template v-slot:cell(to)="row">
                        <span v-if="row.item.to">
                            {{ row.item.to | moment('DD/MM/YYYY HH:mm') }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(status)="row">
                        <span v-if="row.item.status === 'waiting'" class="text-info">
                            Aguardando Início
                        </span>

                        <span v-else-if="row.item.status === 'in_progress'" class="text-primary">
                            Em Andamento
                        </span>

                        <span v-else-if="row.item.status === 'finished'" class="text-success">
                            Finalizada
                        </span>

                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(created_at)="row">
                        <span v-b-tooltip.hover :title="row.item.created_at | moment('DD/MM/YYYY HH:mm')">
                            {{ row.item.created_at | moment('from', 'now') }}
                        </span>
                    </template>

                    <template v-slot:cell(actions)="row">

                        <div class="text-center d-flex">

                            <!-- Details -->
                            <a href="javascript:void(1);" class="mr-2" @click="showDetails(row.item)" v-b-tooltip.hover title="Detalhes da Atividade">
                                <i class="fas fa-eye"></i>
                            </a>

                            <a :href="`/teacher/tasks/create?id=${row.item.id}`" class=""  v-b-tooltip.hover title="Duplicar Atividade">
                                <svg height="18px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                                </svg>
                            </a>

                        </div>

                    </template>

                </b-table>
            </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />
        </div>

        <!-- Show -->
        <show></show>

    </div>
</template>

<script>
import Show from './Show'

export default {
    components: {
        Show,
    },
    props: ['query', 'groups', 'modes', 'teachers'],
    data() {
        return {
            loading: false,
            table: [],
            perPage: 9,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: false,
            fields: [
                { key: 'name', label: 'Nome'},
                { key: 'group.name', label: 'Turma' },
                { key: 'theme.title', label: 'Modo de Correção / Tema' },
                { key: 'teacher.name', label: 'Corretor'},
                { key: 'from', label: 'Data de Início'},
                { key: 'to', label: 'Data de Fim'},
                { key: 'status', label: 'Status'},
                { key: 'created_at', label: 'Criada', sortable: true },
                { key: 'actions', label: '' }
            ],
            filter: {
                name: null,
                group_id: null,
                mode_id: null,
                teacher_id: null
            },
            lastResultsCount: 5,
        }
    },
    watch: {
        'filter.group_id': async function (value) {
            this.filter.group_id = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.mode_id': async function (value) {
            this.filter.mode_id = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.teacher_id': async function (value) {
            this.filter.teacher_id = await value;
            this.currentPage = 1
            await this.load()
        }
    },
    created() {

        // Load
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/tasks', {
                params: {
                    name: this.filter.name,
                    group_id: this.filter.group_id ? this.filter.group_id.id : null,
                    mode_id: this.filter.mode_id ? this.filter.mode_id.id : null,
                    teacher_id: this.filter.teacher_id ? this.filter.teacher_id.id : null,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.tasks.data
                    this.currentPage = response.tasks.current_page
                    this.perPage = response.tasks.per_page
                    this.total = response.tasks.total

                    this.lastResultsCount = response.tasks.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        showDetails(task) {
            this.$root.$emit('tasksShowDetail', task);
        },

    }
}
</script>

<style scoped>

</style>
